module.exports = __webpack_public_path__ + "static/client-code-metro-348bf74019042fc4e5acc9d7b5f53bf6.png";